import { MathUtils, Mesh, PlaneGeometry, RawShaderMaterial, Vector2 } from "three";
import { circle_fragments, vertex_2 } from "../shaders/shader";
import { FboBase } from "./FboBase";

export class CircularMotion extends FboBase {
    constructor(simProps) {
        super({
            common: simProps.common,
            output: simProps.dst
        }),
        this.simProps = simProps,
        this.init(simProps)
    }
    init(simProps) {
        super.init();
        const planeGeo = new PlaneGeometry(1,1)
          , material = new RawShaderMaterial({
            vertexShader: vertex_2,
            fragmentShader: circle_fragments,
            blending: 2,
            uniforms: {
                px: {
                    value: simProps.cellScale
                },
                force: {
                    value: new Vector2(0,0)
                },
                center: {
                    value: new Vector2(0,0)
                },
                scale: {
                    value: new Vector2(simProps.cursor_size,simProps.cursor_size)
                }
            }
        });
        this.mouse = new Mesh(planeGeo,material);
        this.scene.add(this.mouse);
        this.x = 0;
        this.y = 0;
        this.radians = 5;
        this.velocity = .02;
        this.forceXMult = 0;
        this.forceYMult = 0;
    }
    update(e) {
        let t = this.simProps.mouse.diff.x / 2 * e.mouse_force
          , i = this.simProps.mouse.diff.y / 2 * e.mouse_force;
        this.simProps.mouse.diff.x > 0 ? this.forceXMult -= .02 : this.forceXMult += .002;
        this.forceXMult = this.forceXMult > 1 ? 1 : this.forceXMult < 0 ? 0 : this.forceXMult,
        this.simProps.mouse.diff.y > 0 ? this.forceYMult -= .02 : this.forceYMult += .002;
        this.forceYMult = this.forceYMult > 1 ? 1 : this.forceYMult < 0 ? 0 : this.forceYMult;
        
        const s = e.cursor_size * e.cellScale.x
          , r = e.cursor_size * e.cellScale.y;

        let c = Math.min(Math.max(this.simProps.mouse.coords.x, -1 + s + e.cellScale.x * 2), 1 - s - e.cellScale.x * 2)
          , p = Math.min(Math.max(this.simProps.mouse.coords.y, -1 + r + e.cellScale.y * 2), 1 - r - e.cellScale.y * 2);
        const a = this.mouse.material.uniforms;
        this.radians += this.velocity;
        const m = MathUtils.pingpong(this.simProps.common.time * .01, .03);//.03
        
        this.x = 0 + Math.cos(this.radians) * (.1 - m);
        this.y = 0 + Math.sin(this.radians) * (.1 - m);
        c = this.x;
        p = this.y;

        // c = this.x*2;
        // p = this.y*2;

        t = this.x * .5 * this.forceXMult;
        i = this.y * .5 * this.forceYMult;
        // t = this.x * .4 * this.forceXMult;
        // i = this.y * .4 * this.forceYMult;
        a.force.value.set(t, i);
        a.center.value.set(c, p * this.simProps.common.aspect);
        a.scale.value.set(e.cursor_size, e.cursor_size);
        super.update();
    }
}